module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"查看詳細評論","product_button_label":"查看該商品的所有評論"}}')
  delete Component.options._Ctor
}
